import React from "react";
import styled, { keyframes } from "styled-components";
import {
  compassGreyBackground,
  compassLightGreyBackground,
} from "../../styles";
import { CompassParagraph } from "../common/styledComponents";
import { Keyframes } from "styled-components/dist/types";

const CellContainer = styled.div`
  margin-left: 12px;
`;

const pulse = keyframes`
  0% {
    opacity: 0.7;
    background-color: white;
  }
  40% {
    opacity: 0.5;
    background-color:${compassLightGreyBackground};
  }
  100% {
    opacity: 0.7;
    background-color: white;
  }
`;

export const pulseDarker = keyframes`
0% {
  opacity: 0.7;
  background-color: ${compassLightGreyBackground};
}
40% {
  opacity: 0.5;
  background-color:${compassGreyBackground};
}
100% {
  opacity: 0.7;
  background-color: ${compassLightGreyBackground};
}
`;

const StyledLoadingCell = styled.td<LoadingCellProps>`
  padding: ${({ padding }): string => padding || "5px 10px"};
  text-align: center;
  background-color: ${({ bgColor }): string => bgColor || "white"};
  height: ${({ height }): string => height || "0px"};
  width: ${({ width }): string => width || "70px"};
  border: ${({ border }): string => border || "none"};
  animation: ${({ dark }): Keyframes => (dark ? pulseDarker : pulse)} 2.5s
    cubic-bezier(0.4, 0, 0.6, 1) infinite;
  border-radius: 5px;
`;

export const LoadingTableCell = ({
  bgColor,
  height,
  width,
  padding,
  border,
  ml = 20,
  dark = false,
}: LoadingCellProps): JSX.Element => {
  return (
    <CellContainer>
      <StyledLoadingCell
        bgColor={bgColor}
        height={height}
        width={width}
        padding={padding}
        border={border}
        dark={dark}
      >
        <CompassParagraph ml={ml} color="transparent">
          {"Loading"}
        </CompassParagraph>
      </StyledLoadingCell>
    </CellContainer>
  );
};

interface LoadingCellProps {
  bgColor?: string;
  height?: string;
  width?: string;
  padding?: string;
  border?: string;
  ml?: number;
  dark?: boolean;
}
